export default "__VITE_ASSET__CvUTD3Az__"